// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-bg {
    position: absolute;
    top: -10%;
    left: 0;
    width: 100%;
    height: 48vh; /* İstediğiniz yüksekliği buradan ayarlayabilirsiniz */
    background-size: cover;
    background-position: center;
    border-bottom-left-radius: 50% 20%;
    border-bottom-right-radius: 50% 20%;
    z-index: -1;
    opacity: 0.25;
}

.auth-pass-inputgroup .password-addon {
    right: 10px; /* Default position */
}

.auth-pass-inputgroup .password-addon.invalid-padding {
    right: 45px; /* Adjusted position when invalid */
}

.is-invalid ~ .password-addon.invalid-padding {
    right: 45px; /* Adjusted position when invalid */
}
`, "",{"version":3,"sources":["webpack://./src/assets/scss/CreatePassword.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY,EAAE,sDAAsD;IACpE,sBAAsB;IACtB,2BAA2B;IAC3B,kCAAkC;IAClC,mCAAmC;IACnC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW,EAAE,qBAAqB;AACtC;;AAEA;IACI,WAAW,EAAE,mCAAmC;AACpD;;AAEA;IACI,WAAW,EAAE,mCAAmC;AACpD","sourcesContent":[".auth-bg {\n    position: absolute;\n    top: -10%;\n    left: 0;\n    width: 100%;\n    height: 48vh; /* İstediğiniz yüksekliği buradan ayarlayabilirsiniz */\n    background-size: cover;\n    background-position: center;\n    border-bottom-left-radius: 50% 20%;\n    border-bottom-right-radius: 50% 20%;\n    z-index: -1;\n    opacity: 0.25;\n}\n\n.auth-pass-inputgroup .password-addon {\n    right: 10px; /* Default position */\n}\n\n.auth-pass-inputgroup .password-addon.invalid-padding {\n    right: 45px; /* Adjusted position when invalid */\n}\n\n.is-invalid ~ .password-addon.invalid-padding {\n    right: 45px; /* Adjusted position when invalid */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
